import { useMutation, useQueryClient } from "@tanstack/react-query";
import { actualizeazaTargetareLista } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useActualizeazaTargetareLista() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: actualizeazaTargetareLista,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.targetare.liste() });
    },
  });
}
